/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface GetUser200ResponseOnboarding
 */
export interface GetUser200ResponseOnboarding {
    /**
     * 
     */
    completedAt?: Date | null;
    /**
     * 
     */
    dismissedSteps?: Array<string>;
}

/**
 * Check if a given object implements the GetUser200ResponseOnboarding interface.
 */
export function instanceOfGetUser200ResponseOnboarding(value: object): value is GetUser200ResponseOnboarding {
    return true;
}

export function GetUser200ResponseOnboardingFromJSON(json: any): GetUser200ResponseOnboarding {
    return GetUser200ResponseOnboardingFromJSONTyped(json, false);
}

export function GetUser200ResponseOnboardingFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUser200ResponseOnboarding {
    if (json == null) {
        return json;
    }
    return {
        
        'completedAt': json['completedAt'] === undefined ? undefined : json['completedAt'] === null ? null : (parseDateTime(json['completedAt'])),
        'dismissedSteps': json['dismissedSteps'] == null ? undefined : json['dismissedSteps'],
    };
}

export function GetUser200ResponseOnboardingToJSON(json: any): GetUser200ResponseOnboarding {
    return GetUser200ResponseOnboardingToJSONTyped(json, false);
}

export function GetUser200ResponseOnboardingToJSONTyped(value?: GetUser200ResponseOnboarding | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'completedAt': value['completedAt'] == null ? value['completedAt'] : serializeDateTime(value['completedAt']),
        'dismissedSteps': value['dismissedSteps'],
    };
}

